export default __webpack_public_path__ + "b597e6419a28895a95356debcf9dd068.png";